import React from "react";
const FilterSummary = ({
  filters,
  updateFilters,
  setPendingDepartments,
  setPendingSkillsKnown,
  setPendingCourses,
  setPendingBranches,
  setPendingCompanyLocations,
  setPendingExperiences,
  setPendingResumeStatus,
  setPendingFromPassedYear,
  setPendingToPassedYear,
  setPendingGenders,
  setPendingReadyForPlacement,
  clearAllFilters
}) => {
  const hasActiveFilters =
    filters.selectedDepartments?.length > 0 ||
    filters.selectedSkillsKnown?.length > 0 ||
    filters.selectedBranches?.length > 0 ||
    filters.selectedCompanyLocations?.length > 0 ||
    filters.selectedExperiences?.length > 0 ||
    filters.selectedCourses?.length > 0 ||
    filters.selectedGenders?.length > 0 ||
    filters.selectedResumeStatus !== '' ||
    filters.readyForPlacement !== ''

  if (!hasActiveFilters) return null;

  const handleClearFilter = (filterType, value) => {
    const handlers = {
      selectedDepartments: (updated) => {
        updateFilters({ selectedDepartments: updated });
        setPendingDepartments(updated);
      },
      selectedSkillsKnown: (updated) => {
        updateFilters({ selectedSkillsKnown: updated });
        setPendingSkillsKnown(updated);
      },
      selectedCourses: (updated) => {
        updateFilters({ selectedCourses: updated });
        setPendingCourses(updated);
      },
      selectedBranches: (updated) => {
        updateFilters({ selectedBranches: updated });
        setPendingBranches(updated);
      },
      selectedCompanyLocations: (updated) => {
        updateFilters({ selectedCompanyLocations: updated });
        setPendingCompanyLocations(updated);
      },
      selectedExperiences: (updated) => {
        updateFilters({ selectedExperiences: updated });
        setPendingExperiences(updated);
      },
      selectedResumeStatus: () => {
        updateFilters({ selectedResumeStatus: '' });
        setPendingResumeStatus('');
      },
      selectedGenders: (updated) => {
        updateFilters({ selectedGenders: updated });
        setPendingGenders(updated);
      },
      passedYear: () => {
        updateFilters({ fromPassedYear: '', toPassedYear: '' });
        setPendingFromPassedYear('');
        setPendingToPassedYear('');
      },

      // ✅ ADD THIS
      readyForPlacement: () => {
        updateFilters({ readyForPlacement: '' });
        setPendingReadyForPlacement('');
      }
    };

    if (filterType === 'selectedDepartments') {
      const updated = filters.selectedDepartments.filter(d => d !== value);
      handlers.selectedDepartments(updated);
    } else if (filterType === 'selectedSkillsKnown') {
      const updated = filters.selectedSkillsKnown.filter(s => s !== value);
      handlers.selectedSkillsKnown(updated);
    } else if (filterType === 'selectedCourses') {
      const updated = filters.selectedCourses.filter(c => c !== value);
      handlers.selectedCourses(updated);
    } else if (filterType === 'selectedBranches') {
      const updated = filters.selectedBranches.filter(b => b !== value);
      handlers.selectedBranches(updated);
    } else if (filterType === 'selectedCompanyLocations') {
      const updated = filters.selectedCompanyLocations.filter(l => l !== value);
      handlers.selectedCompanyLocations(updated);
    } else if (filterType === 'selectedExperiences') {
      const updated = filters.selectedExperiences.filter(e => e !== value);
      handlers.selectedExperiences(updated);
    } else if (filterType === 'selectedResumeStatus') {
      handlers.selectedResumeStatus();
    } else if (filterType === 'selectedGenders') {
      const updated = filters.selectedGenders.filter(g => g !== value);
      handlers.selectedGenders(updated);
    } else if (filterType === 'passedYear') {
      handlers.passedYear();
    }
    // ✅ ADD THIS
    else if (filterType === 'readyForPlacement') {
      handlers.readyForPlacement();
    }
  };

  return (
    <div className="filter-summary-row">
      <div className="active-filters-summary">
        <span className="filters-label">Active Filters:</span>

        {filters.selectedDepartments?.map((dept, index) => (
          <span key={`department-${index}`} className="filter-badge department">
            {dept}
            <button
              className="clear-filter-btn"
              onClick={() => handleClearFilter('selectedDepartments', dept)}
            >
              ×
            </button>
          </span>
        ))}

        {filters.selectedSkillsKnown?.map((skill, index) => (
          <span key={`skill-${index}`} className="filter-badge skill-known">
            {skill}
            <button
              className="clear-filter-btn"
              onClick={() => handleClearFilter('selectedSkillsKnown', skill)}
            >
              ×
            </button>
          </span>
        ))}

        {filters.selectedCourses?.map((course, index) => (
          <span key={`course-${index}`} className="filter-badge course">
            {course}
            <button
              className="clear-filter-btn"
              onClick={() => handleClearFilter('selectedCourses', course)}
            >
              ×
            </button>
          </span>
        ))}

        {filters.selectedBranches?.map((branch, index) => (
          <span key={`branch-${index}`} className="filter-badge branch">
            {branch}
            <button
              className="clear-filter-btn"
              onClick={() => handleClearFilter('selectedBranches', branch)}
            >
              ×
            </button>
          </span>
        ))}

        {filters.selectedCompanyLocations?.map((location, index) => (
          <span key={`location-${index}`} className="filter-badge company-location">
            {location}
            <button
              className="clear-filter-btn"
              onClick={() => handleClearFilter('selectedCompanyLocations', location)}
            >
              ×
            </button>
          </span>
        ))}

        {filters.selectedExperiences?.map((exp, index) => (
          <span key={`experience-${index}`} className="filter-badge experience">
            {exp}
            <button
              className="clear-filter-btn"
              onClick={() => handleClearFilter('selectedExperiences', exp)}
            >
              ×
            </button>
          </span>
        ))}
        {filters.selectedGenders?.map((gender, index) => (
          <span key={`gender-${index}`} className="filter-badge gender">
            {gender}
            <button
              className="clear-filter-btn"
              onClick={() => handleClearFilter('selectedGenders', gender)}
            >
              ×
            </button>
          </span>
        ))}
        {filters.selectedResumeStatus && (
          <span className="filter-badge resume-status">
            Resume: {filters.selectedResumeStatus === 'uploaded' ? 'Uploaded' : 'Not Uploaded'}
            <button
              className="clear-filter-btn"
              onClick={() => handleClearFilter('selectedResumeStatus')}
            >
              ×
            </button>
          </span>
        )}

        {(filters.fromPassedYear || filters.toPassedYear) && (
          <span className="filter-badge passed-year">
            Year: {filters.fromPassedYear || '...'} - {filters.toPassedYear || '...'}
            <button
              className="clear-filter-btn"
              onClick={() => handleClearFilter('passedYear')}
            >
              ×
            </button>
          </span>
        )}
        {filters.readyForPlacement && (
          <span className="filter-badge ready">
            Ready: {filters.readyForPlacement}
            <button
              className="clear-filter-btn"
              onClick={() => {
                updateFilters({ readyForPlacement: '' });
              }}
            >
              ×
            </button>
          </span>
        )}

        <button onClick={clearAllFilters} className="clear-all-btn">
          Clear All
        </button>
      </div>
    </div>
  );
};

export default React.memo(FilterSummary);